export const getFormattedDeliveryDate = (message: string, deliveryTime: string) => {
  if (!message) return deliveryTime
  const date = new Date(deliveryTime)
  return replaceAll(
    message,
    { expectedTime: date.getTime() ? useDeliveryTime(date) : deliveryTime }
  )
}
